import 'jquery-ui/dist/jquery-ui.min.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'litepicker';
import 'slick-carousel';
import Choices from 'choices.js';
import 'jquery.cookie';
import 'flatpickr/dist/flatpickr.min.js';

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
	var observer = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting === true) {
				entry.target.classList.add("fade-in--is-visible");
			} else {
				//entry.target.classList.remove("fade-in--is-visible");
			}
		});
	});
	var items = document.querySelectorAll(".fade-in");
	items.forEach(function(item, index) {
		observer.observe(item, index);
	});
} else {
	document.querySelector("body").classList.add("no-intersection-observer")
}

/* ==========================================================================
   Change header on scroll
   ========================================================================== */

if ('IntersectionObserver' in window) {
	var headerEl = document.querySelector(".header");
	var sentinalEl = document.querySelector(".header-sentinal");

	var handler = function handler(entries) {
		if (!entries[0].isIntersecting) {
			headerEl.classList.add("header--scrolled");
		} else {
			headerEl.classList.remove("header--scrolled");
		}
	};

	var observer = new window.IntersectionObserver(handler);
	observer.observe(sentinalEl);
}

/* ==========================================================================
   Mobile Menu Button
   ========================================================================== */

const navButton = document.querySelector(".js-trigger-mobile-nav");
const navElement = document.querySelector(".main-nav");

navButton.addEventListener("click", function () {
	navElement.classList.toggle("is-active");
	this.classList.toggle("is-active");
});


/* ==========================================================================
   Mobile Sub Menu Button
   ========================================================================== */

if ($(window).width() < 769) {
	$(".main-nav__link--has-sub-nav").click(function (e) {
		e.preventDefault();
		$(this).toggleClass("main-nav__link--sub-nav-active")
		$(this).parent().find(".sub-nav").slideToggle();
	});
}

/* ==========================================================================
   Cookies Banner
   ========================================================================== */

$(document).ready(function () {
	if (typeof $.cookie('_oa_userCkAccept') === 'undefined') {
		if (document.querySelector(".cookies-popup")) {
			$(".cookies-popup").show();
		}
	}
});

/* ==========================================================================
   Cookies Close Button
   ========================================================================== */

if (document.querySelector(".js-close-cookies-popup")) {
	document.querySelector(".js-close-cookies-popup").addEventListener("click", function (event) {
		event.preventDefault();
		$(".cookies-popup").hide();
		$.cookie("_oa_userCkAccept", true, { expires: 365, path: '/' });
	});
}

/* ==========================================================================
   Header Search Button
   ========================================================================== */

if (document.querySelector(".js-toggle-search")) {
	const headerSearchForm = document.querySelector(".header-search__form");
	document.querySelector(".js-toggle-search").addEventListener("click", function (event) {
		event.preventDefault();
		this.classList.toggle("is-active");
		if (this.getAttribute("aria-expanded") == "true") {
			this.setAttribute("aria-expanded", "false");
			headerSearchForm.setAttribute("aria-hidden", "true");
		} else {
			this.setAttribute("aria-expanded", "true");
			headerSearchForm.setAttribute("aria-hidden", "false");
			setTimeout(function () {
				$('.js-header-search-field').focus();
			}, 100);
		}
		headerSearchForm.classList.toggle("is-active");
	});
}

/* ==========================================================================
   Advanced Search Button
   ========================================================================== */

if (document.querySelector(".js-toggle-advanced-search")) {
	const advancedSearchForm = document.querySelector(".search-form__main-secondary");
	document.querySelector(".js-toggle-advanced-search").addEventListener("click", function (event) {
		event.preventDefault();
		this.classList.toggle("is-active");
		if (this.getAttribute("aria-expanded") == "true") {
			this.setAttribute("aria-expanded", "false");
			advancedSearchForm.setAttribute("aria-hidden", "true");
		} else {
			this.setAttribute("aria-expanded", "true");
			advancedSearchForm.setAttribute("aria-hidden", "false");
		}
		advancedSearchForm.classList.toggle("is-active");
	});
}

/* ==========================================================================
   Litepicker - Date Range Picker
   ========================================================================== */

// Options - https://wakirin.github.io/Litepicker/
//if (document.querySelector(".js-lightpicker")) {
//	var picker = new Litepicker({
//		element: document.querySelector(".js-lightpicker"),
//		numberOfMonths: 2,
//		numberOfColumns: 2,
//		autoApply: true,
//		showTooltip: true,
//		mobileFriendly: true,
//		format: "D MMM, YYYY",
//		lanf: "en-NZ",
//		singleMode: false
//	});
//}

/* ==========================================================================
   Choices.js Multi select
   ========================================================================== */

// Options - https://github.com/jshjohnson/Choices
if (document.querySelector(".js-choices")) {
	let element = document.querySelector('.js-choices');
	window.choices = new Choices(element, {
		removeItemButton: true
	});
}

/* ==========================================================================
   Slick Slider
   ========================================================================== */

$('.image-slider').slick({
	adaptiveHeight: true,
	fade: true,
	arrows: true,
	dots: false,
	prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Prev</span> <svg class="icon" role="presentation"><use xlink:href="#icon-arrow-left"></use></svg></button>',
	nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next</span> <svg class="icon" role="presentation"><use xlink:href="#icon-arrow-right"></use></svg></button>'
});

/* ==========================================================================
   make videos added in rte responsive
   ========================================================================== */

// wrap YouTube & vimeo iframe in <div class="responsive-container">
detectVideoEmbedIframes($("iframe"));
function detectVideoEmbedIframes(obj) {
	obj.each(function () {
		var iframeURL = $(this).attr("src");
		if (iframeURL != undefined && (iframeURL.indexOf("youtube") > -1 || iframeURL.indexOf("vimeo") > -1)) {
			$(this).wrap('<div class="responsive-container"></div>');
		}
	});
};

/* ==========================================================================
   offset user added # links by header height
   ========================================================================== */

$("a").on("click", function (e) {
	var elementHref = $(this).attr("href");
	if (elementHref && elementHref.length > 1 && elementHref.startsWith("#") && $(elementHref).length) {
		//ignore existing # links (event registration anchor tags and poi filters)
		if ($(this).parents("#event-registration").length || $(this).parents(".poi__filters").length) return;
		
		var headerOuterHeight = $('.header').outerHeight();
		var headerScrolledOffset = 25; //header reduces by 25px after scroll
		var offset = headerOuterHeight - headerScrolledOffset;
		e.preventDefault();
		$('html, body').animate({
			scrollTop: $(elementHref).offset().top - offset
		}, 0);
	}
});

/* ==========================================================================
   Ensure SiteEntryOnMicrosite session is set
   ========================================================================== */

$(document).ready(function () {
	$.ajax({
		url: '/umbraco/surface/SiteEntry/OnMicrosite',
		type: 'POST',
		data: {
			siteEntryOnMicrosite: $("body").hasClass("page-subSectionLanding")
		}
	});
});

/* ==========================================================================
   jQuery UI - Accordion
   ========================================================================== */

if (document.querySelector(".accordion")) {
	$(".accordion").accordion({
		collapsible: true,
		heightStyle: "content",
		active: false
	});
}
